import axios from 'axios'

export default {
  patientChangeGet: function (id) {
    return axios.get('/api/patientchange/get/'+id)
  },
  patientChangeRead: function (id) {
    return axios.post('/api/patientchange/read/'+id)
  }
};
